import apiClient from './apiClient';

export interface QueryParams {
  yearFrom?: number;
  monthFrom?: number;
  monthTo?: number;
  deptFrom?: string;
  deptTo?: string;
  deptLevel?: number;
  unapproved?: boolean;
}

export interface LeaveTypeInfo {
  code: string;
  name: string;
  unit: string;
}

export interface LeaveSummaryRow {
  emp_code: string;
  year_mon: string;
  dept_code: string;
  dept_name: string;
  emp_name: string;
  leave_hours: number[]; // index 0 unused, slots 1..12
  h_tot: number;
  d_tot: number;
}

export interface QueryResponse {
  leave_types: LeaveTypeInfo[];
  data: LeaveSummaryRow[];
  count: number;
  message?: string;
}

export const pw9314Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9314/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pw9314/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
